var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultTabBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.958 29.208C9.09733 29.208 8.35433 28.8957 7.729 28.271C7.10433 27.6457 6.792 26.9027 6.792 26.042V4.042C6.792 3.15267 7.10433 2.40267 7.729 1.792C8.35433 1.18067 9.09733 0.875 9.958 0.875H31.958C32.8473 0.875 33.5973 1.18067 34.208 1.792C34.8193 2.40267 35.125 3.15267 35.125 4.042V26.042C35.125 26.9027 34.8193 27.6457 34.208 28.271C33.5973 28.8957 32.8473 29.208 31.958 29.208H9.958ZM4.042 35.125C3.15267 35.125 2.40267 34.8193 1.792 34.208C1.18067 33.5973 0.875 32.8473 0.875 31.958V6.792H4.042V31.958H29.208V35.125H4.042Z",
    fill: "#F8BD25"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultTabBackground);
export default __webpack_public_path__ + "static/media/defaultTabBackground.111fd892e6d968984998f5071cf69c86.svg";
export { ForwardRef as ReactComponent };